import { PregnancyDateRange } from './PregnancyDateFields.types';

export const isPregnancyDateRange = (value: unknown): value is PregnancyDateRange => {
   return value === null || (typeof value === 'object' && 'start' in value);
};
